import { productPrimaryImageStyles } from "@insite/content-library/Components/ProductPrimaryImage";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

productPrimaryImageStyles.centeringWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;

        border: 1px solid rgba(151, 151, 151, 1);
        opacity: 1;
        margin-top: 12px;

        img {
            aspect-ratio: 2.1/1.2;
            object-fit: cover;
            width: 100%;

            height: auto;
        }
    `,
};
